export default __webpack_public_path__ + "static/media/cow.f0917321.png";